import {Component, Inject, OnInit} from "@angular/core";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Language} from "../../../models/language";

@Component({
    selector: "app-add-cv-lang-dialog",
    templateUrl: "./add-cv-lang-dialog.component.html",
    styleUrls: ["./add-cv-lang-dialog.component.scss"],
})
export class AddCvLangDialogComponent implements OnInit {
    languageForm: UntypedFormGroup;

    languageKnowledge: string[] = ["A1", "A2", "B1", "B2", "C1", "C2"];

    languages: string[] = [
        "Албански",
        "Англиски",
        "Бугарски",
        "Германски",
        "Грчки",
        "Италиjански",
        "Македонски",
        "Норвешки",
        "Полски",
        "Романски",
        "Руски",
        "Словачки",
        "Словенски",
        "Српски",
        "Турски",
        "Украински",
        "Француски",
        "Хрватски",
        "Чешки",
        "Шветски",
        "Шпански",
    ];

    constructor(
        public dialogRef: MatDialogRef<AddCvLangDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Language,
        private formBuilder: UntypedFormBuilder
    ) {
    }

    ngOnInit(): void {
        this.languageForm = this.formBuilder.group({
            languageNameControl: [null, Validators.required],
            hearingControl: [null, Validators.required],
            readingControl: [null, Validators.required],
            interactionControl: [null, Validators.required],
            speakingControl: [null, Validators.required],
            writingControl: [null, Validators.required],
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.languageForm.valid) {
            this.dialogRef.close(this.data);
        } else this.languageForm.updateValueAndValidity();
    }
}
